
import macro from './macro'
import catalogs from './catalogs'

/**
 * Fetches configured preloaded data.
 * @return {Promise} A Promise to fetch all data.
 */
const prefetchService = () => {
  return Promise.all([
    ...macro(),
    ...catalogs()
  ].map(p => p.catch(err => console.error('Error fetching', err))))
}

export default prefetchService
